export default __webpack_public_path__ + "static/media/fitnessTracker.031e5f16.png";